import { createContext } from 'react';

import { translations } from './translations';

export const TranslationsContext = createContext(translations());

TranslationsContext.displayName = 'Translations Context';
